import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {ReactiveFormsModule, UntypedFormGroup} from "@angular/forms";
import {Subject} from "rxjs";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {NgIf} from "@angular/common";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'app-custom-checkbox',
    imports: [
        ReactiveFormsModule,
        FaIconComponent,
        NgIf
    ],
    templateUrl: './checkbox.component.html',
    styleUrl: './checkbox.component.scss'
})
export class CheckboxComponent implements OnInit, OnChanges, OnDestroy {
  @Input() id: string;
  @Input() label: any;
  @Input() title: string;
  @Input() customFormGroup: UntypedFormGroup;
  @Input() placeholder = '';
  @Input() readonly = false;
  @Input() isSwitch = false; // If true, renders as a switch instead of a checkbox
  @Input() infoText;
  @Input() infoTextBelowInput: string;

  @Output() onChange = new EventEmitter();

  destroySub$: Subject<void> = new Subject<void>();

  ngOnInit() {
    this.setReadonly();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.readonly && changes.readonly.currentValue !== changes.readonly.previousValue) {
      this.setReadonly();
    }
  }

  setReadonly() {
    if (this.readonly) {
      this.getFormItem(this.id)?.disable();
    } else {
      this.getFormItem(this.id)?.enable();
    }
  }

  getFormItem(id: string) {
    return this.customFormGroup?.get(id);
  }

  triggerOnChange($event) {
    this.onChange.emit($event);
  }

  ngOnDestroy(): void {
    this.destroySub$.next();
    this.destroySub$.complete();
  }
  getTitle(): string{
    return this.title ?? this.label;
  }

  protected readonly faInfo = faInfoCircle;
}
